<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="modal fade" id="costumModaldisclaimer" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Penjelasan dan Ketentuan</h4>
                </div>
                <div class="modal-body text-justify">
                    <p style="font-size: smaller;">
                        <b>SIMFAST JATENG</b> (Sistem Manajemen Infrastruktur Terpadu Jawa Tengah)
                        yang selanjutnya dioptimalkan sebagai "<b>Strategi Mensinergikan Fokus dan Arah Kebijakan
                        Perencanaan Berbasis Data Spasial Terpadu di Jawa Tengah</b>" merupakan sistem manajemen (alat
                        kerja) yang mengintegrasikan analisa data dan informasi infrastruktur (terkait Urusan PUPR,
                        Perhubungan, Prakim, LHK, ESDM, Kominfo) secara terpadu dengan sektor lain (ekonomi dan sosial)
                        untuk menghasilkan prioritas rencana penanganan infrastruktur di Jawa Tengah yang paling efektif
                        dan efisien dalam mewujudkan tujuan pembangunan di Provinsi Jawa Tengah.
                    </p>
                    <p class="text-center">
                    <div class="row">
                        <div class="col-sm-12 float-left">
                            <label style="font-size: smaller;" class="text-success">Silahkan Mengisi Daftar
                                Pengunjung</label>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="far fa-address-card"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="nama" name="nama"
                                    placeholder="Nama" v-model="nama">
                            </div>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-phone-square"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="hp" name="hp"
                                    placeholder="Nomor Telepon" v-model="hp" @keypress="onlyNumberKey(event)"
                                    @keydown="onlyNumberKey(event)">
                            </div>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-clipboard-list"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="keperluan" name="keperluan"
                                    placeholder="Keperluan" v-model="keperluan">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left">
                            <label style="font-size: smaller;" class="text-success">Kode Keamanan</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-key"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="capcha" name="capcha"
                                    placeholder="Kode Keamanan" v-model="capcha" disabled @click.right.prevent
                                    @keydown="keydown" @copy.prevent @paste.prevent>
                            </div>
                        </div>
                        <div class="col-sm-6 float-left">
                            <label style="font-size: smaller;" class="text-success">Ulangi Kode Keamanan</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="far fa-clone"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="capchainput"
                                    name="capchainput" v-model="capchainput" style="text-transform:uppercase"
                                    @click.right.prevent @keydown="keydown" @copy.prevent @paste.prevent>
                            </div>
                        </div>
                    </div>
                    <input type="checkbox" id="customSwitchAuth" @click="rubahisi()">
                    <label style="font-size: small;" for="customSwitchAuth">
                        &nbsp;Saya mengerti dan menyetujui penjelasan dan ketentuan diatas.
                    </label>
                    </p>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger2 btn-block text-white" placeholder="Setuju dan lanjutkan"
                        data-toggle="tooltip" data-placement="left" title="Setuju dan lanjutkan.." style="color: black;"
                        :disabled="showHuman == false" @click="setuju()">
                        <b>
                            Setuju dan lanjutkan
                        </b>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInUp pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">PROFIL DATA KEMISKINAN PROVINSI JAWA TENGAH</span>
                <span v-else>PROFIL DATA KEMISKINAN PROVINSI JAWA TENGAH</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInUp" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-primary">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Profil Data Kemiskinan
                        Provinsi Jawa
                        Tengah</span>
                    <span v-else>Profil Data Kemiskinan Provinsi Jawa
                        Tengah</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <div class="container-fluid py-4 wow fadeInUp" data-wow-delay="0.1s">
        <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
            style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
            <div class="sub-style">
                <h4 class="sub-title px-3 mb-0 labelpmis">
                    DATA PRIORITAS KEMISKINAN REGULER BASIS DESA / KELURAHAN PROVINSI JAWA TENGAH
                </h4>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12 text-center py-2">
                    <a class="hitam">
                        <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                            data-placement="left" title="Unduh excel.."
                            @click="G_tableCSVTabel2('_DaftarDesaPrioritasKemiskinan_')">
                            <i class="fas fa-download"></i>
                            <span>
                                Unduh Data .xlsx
                            </span>
                        </button>
                    </a>
                </div>
                <div class="col-sm-12 float-left pb-2">
                    <center>
                        <div class="spinner-border text-danger text-center" style="width: 3rem; height: 3rem;"
                            role="status" v-show="datamaster.length == 0">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <span v-show="datamaster.length == 0">Loading Data .....</span>
                    </center>
                    <div class="table-responsive table-wrapper">
                        <table class="table m-0" id="tabeldata" style="font-size: small;">
                            <thead>
                                <tr>
                                    <th style="width: 50px;" rowspan="3">No</th>
                                    <th style="width: 50px;" rowspan="3">Tahun</th>
                                    <th style="width: 150px;" rowspan="3">Lokasi</th>
                                    <th style="width: 200px;" colspan="8">Jumlah</th>
                                </tr>
                                <tr>
                                    <th style="width: 150px;" colspan="3">Kategori</th>
                                    <th style="width: 50px;" rowspan="2">Total</th>
                                    <th style="width: 150px;" colspan="3">Persentase</th>
                                    <th style="width: 50px;" rowspan="2">Total</th>
                                </tr>
                                <tr>
                                    <th style="width: 50px;">Prioritas 1</th>
                                    <th style="width: 50px;">Prioritas 2</th>
                                    <th style="width: 50px;">Prioritas 3</th>
                                    <th style="width: 50px;">Prioritas 1</th>
                                    <th style="width: 50px;">Prioritas 2</th>
                                    <th style="width: 50px;">Prioritas 3</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                                    <tr>
                                        <td class="total text-center">
                                            {{ (urutlist + 1) }}
                                        </td>
                                        <td class="total text-center">
                                            {{ datalist.tahun }}
                                        </td>
                                        <template v-for="(datadetail, urutdetail) in datalist.detail" :key="urutdetail">
                                            <td class="total text-left">
                                                {{ datadetail.nama }}
                                            </td>
                                            <td class="total text-center" data-z="#,##0"
                                                :data-v="datadetail.prioritas1">
                                                {{ G_numFormat(datadetail.prioritas1) }}
                                            </td>
                                            <td class="total text-center" data-z="#,##0"
                                                :data-v="datadetail.prioritas2">
                                                {{ G_numFormat(datadetail.prioritas2) }}
                                            </td>
                                            <td class="total text-center" data-z="#,##0"
                                                :data-v="datadetail.prioritas3">
                                                {{ G_numFormat(datadetail.prioritas3) }}
                                            </td>
                                            <td class="total text-center" data-z="#,##0"
                                                :data-v="datadetail.jumlahdesa">
                                                {{ G_numFormat(datadetail.jumlahdesa) }}
                                            </td>
                                            <td class="total text-center" data-z="#,##0"
                                                :data-v="datadetail.persenprioritas1">
                                                {{ G_numFormatKoma(datadetail.persenprioritas1) }}
                                            </td>
                                            <td class="total text-center" data-z="#,##0"
                                                :data-v="datadetail.persenprioritas2">
                                                {{ G_numFormatKoma(datadetail.persenprioritas2) }}
                                            </td>
                                            <td class="total text-center" data-z="#,##0"
                                                :data-v="datadetail.persenprioritas3">
                                                {{ G_numFormatKoma(datadetail.persenprioritas3) }}
                                            </td>
                                            <td class="total text-center" data-z="#,##0"
                                                :data-v="datadetail.persenjumlahdesa">
                                                {{ G_numFormatKoma(datadetail.persenjumlahdesa) }}
                                            </td>
                                        </template>
                                    </tr>
                                    <template v-for="(datadetail, urutdetail) in datalist.detail" :key="urutdetail">
                                        <template v-for="(dataunit, urutunit) in datadetail.detail" :key="urutunit">
                                            <tr>
                                                <td class="text-center">
                                                    {{ (urutlist + 1) }}.{{ (urutunit + 1) }}
                                                </td>
                                                <td class="text-center">
                                                    {{ datalist.tahun }}
                                                </td>
                                                <td class="text-left">
                                                    {{ dataunit.nama }}
                                                </td>
                                                <td class="text-center" data-z="#,##0"
                                                    :data-v="dataunit.prioritas1">
                                                    {{ G_numFormat(dataunit.prioritas1) }}
                                                </td>
                                                <td class="text-center" data-z="#,##0"
                                                    :data-v="dataunit.prioritas2">
                                                    {{ G_numFormat(dataunit.prioritas2) }}
                                                </td>
                                                <td class="text-center" data-z="#,##0"
                                                    :data-v="dataunit.prioritas3">
                                                    {{ G_numFormat(dataunit.prioritas3) }}
                                                </td>
                                                <td class="text-center" data-z="#,##0"
                                                    :data-v="dataunit.jumlahdesa">
                                                    {{ G_numFormat(dataunit.jumlahdesa) }}
                                                </td>
                                                <td class="text-center" data-z="#,##0"
                                                    :data-v="dataunit.persenprioritas1">
                                                    {{ G_numFormatKoma(dataunit.persenprioritas1) }}
                                                </td>
                                                <td class="text-center" data-z="#,##0"
                                                    :data-v="dataunit.persenprioritas2">
                                                    {{ G_numFormatKoma(dataunit.persenprioritas2) }}
                                                </td>
                                                <td class="text-center" data-z="#,##0"
                                                    :data-v="dataunit.persenprioritas3">
                                                    {{ G_numFormatKoma(dataunit.persenprioritas3) }}
                                                </td>
                                                <td class="text-center" data-z="#,##0"
                                                    :data-v="dataunit.persenjumlahdesa">
                                                    {{ G_numFormatKoma(dataunit.persenjumlahdesa) }}
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import { ref } from 'vue'
import treeview from "vue3-treeview";
import "vue3-treeview/dist/style.css";
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import xlsx from 'xlsx/dist/xlsx.full.min';
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";
import vSelect from 'vue-select';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-Regular, Arial, sans-serif" };

export default {
    components: {
        Top, Footer, swal, tree: treeview, vSelect
    },
    data() {
        return {
            halamanloading: true,
            showHuman: false,
            tampilmodal: localStorage.getItem("bookstamu"),
            capcha: this.makeid(5), capchainput: "",
            nama: '',
            hp: '',
            keperluan: '',
            ipnya: '',
            datapesan: '',
            datamaster: [],
            carikata: '',
            colspan: 0,
        };
    },
    methods: {
        async G_tableCSVTabel2(namefile) {
            this.halamanloading = true;
            const XLSX = xlsx;
            var wb = XLSX.utils.table_to_book(document.getElementById('tabeldata'), { sheet: "DaftarDesaPrioritasKemiskinan" });
            XLSX.writeFile(wb, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
            this.halamanloading = false;
        },
        onlyNumberKey(evt) {
            // Only ASCII character in that range allowed
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            } return;
        },
        rubahisi() {
            if ((this.showHuman == false) && (this.capcha == this.capchainput.toUpperCase())) {
                if (this.nama.length <= 2) {
                    this.showHuman = false;
                    document.getElementById("customSwitchAuth").checked = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan nama dengan benar',
                    });
                    return false;
                }
                if ((this.hp.length <= 4) || (typeof parseInt(this.hp) != "number")) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan nomor telp dengan benar',
                    });
                    return false;
                }
                if (this.keperluan.length <= 3) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan keperluan dengan benar',
                    });
                    return false;
                }
                this.showHuman = true;
            }
            else {
                if (this.capcha != this.capchainput.toUpperCase()) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Kode keamanan tidak sama',
                    });
                }
                this.showHuman = false;
            }
        },
        async setuju() {
            this.halamanloading = true;

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });

            this.halamanloading = true;
            const data = {
                tamuparastapa: 'tamuparastapa',
                nama: this.nama,
                hp: this.hp,
                keperluan: this.keperluan,
            };
            const mainAPIVisitor = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            await mainAPIVisitor.post("parastapainnovatioBukuTamu-IsiTamu", data).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: Response.data.message,
                        });
                        this.halamanloading = false;
                        return false;
                    }
                    else {
                        localStorage.setItem("bookstamu", new Date().toString());
                        $('#costumModaldisclaimer').modal('hide');
                        this.halamanloading = false;
                        //window.location.reload();
                    }
                }
            ).catch(
                error => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: error,
                    });
                }
            )

        },
        async cekdisklaimer() {
            if ((this.tampilmodal == null) || (this.tampilmodal == '') || (this.tampilmodal == undefined)) {
                $('#costumModaldisclaimer').modal('show');
            }

            var time = Date.parse(localStorage.getItem("bookstamu"));
            var timeakhir = time + (1 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                $('#costumModaldisclaimer').modal('show');
            }
        },
        async ambildata() {
            this.halamanloading = true;

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });

            const mainAPI2 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                },
            });
            var random = Math.random();
            await mainAPI2.get("parastapainnovationsprofilkemiskinan-GetData?random=" + random + "&tahun=").then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.colspan = this.datamaster.length;
                    }
                    else {
                        this.datamaster = [];
                        this.colspan = 0;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.datamaster = [];
                this.colspan = 0;
                //console.log(error);
                this.halamanloading = false;
            });

        },
    },
    mounted() {
        this.ambildata();
        this.cekdisklaimer();
        window.addEventListener('keydown', function (event) {
            if (event.code == 'KeyZ' && (event.ctrlKey || event.metaKey)) {
                localStorage.setItem("bookstamu", new Date().toString());
                $('#costumModaldisclaimer').modal('hide');
            }
        });
    },
}
</script>

<style></style>